const LOCATION_REFRESH_MS = 10 * 60 * 1000;

const POSITION_OPTIONS = {
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: 10000,
};

let cachedLocation = null;
let watchId = null;
let refreshTimer = null;

function onPosition(pos) {
  cachedLocation = {
    latitude: pos.coords.latitude,
    longitude: pos.coords.longitude,
  };
}

function onPositionError() {
  cachedLocation = null;
}

export function startLocationTracking() {
  if (!navigator.geolocation || watchId !== null) return;

  // cachedLocation is module scope, so a page refresh clears it and this watch
  // re-acquires a fresh fix (maximumAge: 0 stops the browser replaying an old one).
  watchId = navigator.geolocation.watchPosition(
    onPosition,
    onPositionError,
    POSITION_OPTIONS,
  );

  // The watch stays silent while the device is stationary, so without this a tab
  // left open would keep sending the fix it acquired on load.
  refreshTimer = setInterval(() => {
    navigator.geolocation.getCurrentPosition(
      onPosition,
      onPositionError,
      POSITION_OPTIONS,
    );
  }, LOCATION_REFRESH_MS);
}

export function stopLocationTracking() {
  if (watchId !== null) {
    navigator.geolocation.clearWatch(watchId);
    watchId = null;
  }
  if (refreshTimer !== null) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
  cachedLocation = null;
}

export function getLocationHeaders() {
  const headers = { "X-Device": navigator.userAgent };
  if (cachedLocation) {
    headers["X-Latitude"] = String(cachedLocation.latitude);
    headers["X-Longitude"] = String(cachedLocation.longitude);
    headers["X-Location-Type"] = "gps";
  }
  return headers;
}
